import type UnidadeOrganizacional from "model/indicadores/UnidadeOrganizacional";

export default class SerieNotaFiscal {
    id: number | null;
    unidadeOrganizacional: UnidadeOrganizacional | null;
    modelo: string;
    numeroSerie: number;
    ultimoNumeroUtilizado: number | null;
    dataUltimaEmissao: string | null;
    ativa: boolean;
    ambiente: string;
    descricao: string;
    controleNumeracao: string;

    constructor(
        id: number | null = null,
        unidadeOrganizacional: UnidadeOrganizacional | null = null,
        modelo = 'NFE',
        numeroSerie = 0,
        ultimoNumeroUtilizado: number | null = 0,
        dataUltimaEmissao: string | null = null,
        ativa = true,
        ambiente = 'HOMOLOGACAO',
        descricao = '',
        controleNumeracao = 'EMPX'
    ) {
        this.id = id;
        this.unidadeOrganizacional = unidadeOrganizacional;
        this.modelo = modelo;
        this.numeroSerie = numeroSerie;
        this.ultimoNumeroUtilizado = ultimoNumeroUtilizado;
        this.dataUltimaEmissao = dataUltimaEmissao;
        this.ativa = ativa;
        this.ambiente = ambiente;
        this.descricao = descricao;
        this.controleNumeracao = controleNumeracao;
    }
}
